import { RequiredFiltersValidation } from ".";
import { SearchAttribute } from "../../../../../../../../models/search.attribute";
import { Filters } from "../../../../../../../../models/shipeezi.table";
import { CategoryForLocalFilter, GenericObject } from "../../../../../../../../types";
import { ReportName } from "../../../../../../../../util/enums";

export const isOldReport = (type?: string) => {
  if (!type) {
    return false;
  }

  return [
    ReportName.CROSS_DOCK_STATUS,
    ReportName.STOCK_ON_HAND,
    ReportName.STOCK_ON_HAND_DETAILED,
  ].includes(type as ReportName);
};

interface TransformFiltersForLocalKeysProps {
  filterCategories?: CategoryForLocalFilter[];
  filters?: Filters;
  keysToexcludeFromLocalFilter?: string[];
}

export const removeKeysFromObject = (obj: any, keysToRemove: string[]) => {
  return Object.fromEntries(
    Object.entries(obj ?? {}).filter(([key]) => !keysToRemove?.includes(key))
  );
};

export const transformFiltersForLocalKeys = ({
  filterCategories,
  filters,
  keysToexcludeFromLocalFilter,
}: TransformFiltersForLocalKeysProps) => {
  const filterCopy = removeKeysFromObject(filters, keysToexcludeFromLocalFilter ?? []) as Filters;

  filterCategories?.forEach((option) => {
    if (option.column) {
      const currentParameter = filterCopy[option.column];

      if (option.localKey) {
        if (currentParameter?.length && option.column) {
          filterCopy[option.localKey] = option.getOptionLabel
            ? currentParameter?.map((param) => option?.getOptionLabel?.(param) ?? "")
            : currentParameter;

          delete filterCopy[option.column];
        }
      }
    }
  });

  return filterCopy;
};

export const filterBaseGridReport = (
  data: any[],
  searchAttributes?: SearchAttribute[],
  filters?: Filters
) => {
  let filteredData = data;

  if (filters) {
    filteredData = data.filter((row) => {
      return Object.entries(filters).every(([key, values]) =>
        values.map((value) => value?.toLowerCase())?.includes(row[key]?.toLowerCase())
      );
    });
  }

  return searchAttributes?.reduce((filteredBySearchAttributes, searchAttribute) => {
    const { attribute, values } = searchAttribute;

    if (attribute.includes(".")) {
      const [objectName, objectProperty] = attribute.split(".");

      return filteredBySearchAttributes.filter((item: GenericObject) => {
        return values.some((value: string) => {
          const nestedObject = item?.[objectName];

          return String(nestedObject?.[objectProperty])
            ?.toLowerCase()
            .includes(value.toLowerCase());
        });
      });
    }

    return filteredBySearchAttributes.filter((item: GenericObject) => {
      return values.some((value: string) =>
        String(item[attribute])?.toLowerCase().includes(value.toLowerCase())
      );
    });
  }, filteredData);
};

export const requiredFiltersMessage = (requiredFilters: RequiredFiltersValidation[]) => {
  if (requiredFilters.length === 1) return requiredFilters[0].title;
  const titles = [...requiredFilters.map((filter) => filter.title)];
  const last = titles.pop();
  const message = `${titles.join(", ")} and ${last}`;

  return message;
};
